import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import store from 'store';
import getDashboardApiUrl from '@/utils/getDashboardApiUrl';

export type ApiTokenScope = 'read' | 'write';

export interface ApiToken {
  _id: string;
  name: string;
  tokenPrefix: string;
  scopes: ApiTokenScope[];
  allLocations: boolean;
  lastUsedAt: string | null;
  createdAt: string;
  createdBy: string | null;
}

export interface CreateApiTokenBody {
  name: string;
  readOnly: boolean;
  allLocations: boolean;
}

export interface CreateApiTokenResponse {
  apiToken: ApiToken;
  token: string;
}

const LIST_TAG = { type: 'ApiToken' as const, id: 'LIST' };

export const apiTokensApi = createApi({
  reducerPath: 'apiTokensApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getDashboardApiUrl(window.location.href),
    prepareHeaders: (headers) => {
      const token = store.get('jwt');
      if (token) {
        headers.set('Authorization', `JWT ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['ApiToken'],
  endpoints: (builder) => ({
    getApiTokens: builder.query<{ apiTokens: ApiToken[] }, void>({
      query: () => ({ url: '/api/api-tokens' }),
      providesTags: [LIST_TAG],
    }),
    createApiToken: builder.mutation<CreateApiTokenResponse, CreateApiTokenBody>({
      query: (body) => ({ url: '/api/api-tokens', method: 'POST', body }),
      invalidatesTags: [LIST_TAG],
    }),
    revokeApiToken: builder.mutation<{ revoked: boolean }, string>({
      query: (_apiToken) => ({ url: `/api/api-tokens/${_apiToken}/revoke`, method: 'POST' }),
      invalidatesTags: [LIST_TAG],
    }),
  }),
});

export const { useGetApiTokensQuery, useCreateApiTokenMutation, useRevokeApiTokenMutation } =
  apiTokensApi;
